import React, { Component } from 'react'
import { connect } from "react-redux";
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router"
import { searchActions } from '../../store/searchStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Circles } from '../common/loadingComponent';
import BbCheckbox from "../styling/bbCheckbox";
import LiensSearchResultPage from './liens/liensSearchResultPage';
import NoDataComponent from '../common/noDataComponent';
import Paging from "../common/pagingComponent";

class LiensSearchResult extends Component {

    componentDidMount() {
        const data = this.getSearchParams();
        if (!isNullOrUndefined(data))
            this.props.getLiens(data);
    }

    componentDidUpdate(prevProps, _prevState) {
        if (this.props.search.languageChanged) {
            this.props.getLiens(this.getSearchParams());
        }
    }

    getSearchParams() {
        const historyData = !isNullOrUndefined(this.props.history) && !isNullOrUndefined(this.props.history.location) ? this.props.history.location.state : undefined;
        return isNullOrUndefined(this.props.location.state) ? historyData : this.props.location.state;
    }

    render = () => {
        const data = isNullOrUndefined(this.props.search.searchResult) ? null : this.props.search.searchResult.data;
        const isSearching = isNullOrUndefined(this.props.search) ? false : this.props.search.isSearching;

        if (isSearching)
            return <Circles />

        if (isNullOrUndefined(data) || this.props.search.searchResult.data.found === 0) {
            return (
                <NoDataComponent />
            );
        }

        const found = data.found || 0;
        const page = this.props.search.searchParams.page;
        const pageSize = this.props.search.searchParams.pageSize;
        const includedInExportIds = Object.assign([], this.props.search.exportSettings.ids).includes(data.items[0].id);

        return (
            <>
                <div className='card card-special' style={{ fontSize: "0.875em" }}>
                    <div className="card-body">
                        <div className="bb-chk-pdf-export m-0">
                            <BbCheckbox name="pdf-id" label={this.props.translate("Common.AddToReport")} id="pdf-id"
                                value={(this.props.search.exportSettings.all && !includedInExportIds) || (!this.props.search.exportSettings.all && includedInExportIds)}
                                onChange={(v) => v ? this.props.addToPdfExport(data.items[0].id) : this.props.removeFromPdfExport(data.items[0].id)} />
                        </div>
                        <LiensSearchResultPage data={this.props.search.searchResult.data.items[0]} />
                    </div>
                </div>
                { this.renderPaging(found, page, pageSize)}
            </>
        )
    }

    renderPaging = (totalCount, page, pageSize) => {
        return (page && Math.ceil(totalCount / pageSize) > 1) ? (
            <div className="paging-wrapper">
                <Paging selectedPage={page}
                    totalPages={Math.ceil(totalCount / pageSize)}
                    setPage={p => {
                        this.props.changePageLiens(p);
                    }} />
            </div>
        ) : null;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, search: state.search, user: state.userContext }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(LiensSearchResult)));
